import { normalizeMessageSection } from './messageRules';
// Retain old chat fields for saved configurations; shared agent settings control messages and default inactivity timing.
export const normalizeChat = (chat = {}) => ({
  enabled: 'No',
  tool_wait_delay_seconds: 4,
  ...normalizeMessageSection(chat, ['opening_message', 'closing_message', 'transfer_message'], ['chat']),
  session: { max_user_messages: 50, max_message_characters: 500, ...chat?.session },
});

export const supportsChat = (agent, allowedConfig) => (
  agent?.pipeline_type === 'stt_llm_tts'
  && Boolean(agent?.llm?.provider && agent?.llm?.model)
  && (!allowedConfig || Object.prototype.hasOwnProperty.call(
    allowedConfig.llm?.[agent.llm.provider] || {}, agent.llm.model,
  ))
);

export const canTestChat = (agent, allowedConfig) => (
  supportsChat(agent, allowedConfig) && agent?.chat?.enabled === 'Yes'
);

export const changeAgentPipeline = (agent, pipelineType) => {
  const chat = normalizeChat(agent.chat);
  return {
    ...agent,
    pipeline_type: pipelineType,
    chat: { ...chat, enabled: pipelineType === 'stt_llm_tts' ? chat.enabled : 'No' },
  };
};

export const buildChatTestTarget = ({ agent, version, useDraft }) => ({
  agent_id: agent.agent_id,
  ...(useDraft ? { draft_configuration: JSON.parse(JSON.stringify(agent)) }
    : Number.isInteger(version) && version > 0 ? { version } : {}),
});

export const validateChat = (agent, allowedConfig) => {
  const chat = normalizeChat(agent?.chat);
  const errors = {};
  if (!['Yes', 'No'].includes(chat.enabled)) errors['chat.enabled'] = 'Use Yes or No.';
  if (chat.enabled === 'Yes' && !supportsChat(agent, allowedConfig)) {
    errors['chat.enabled'] = 'Chat requires an STT → LLM → TTS agent and a supported text LLM.';
  }
  const integer = (value, min, max, path) => {
    if (!Number.isInteger(value) || value < min || value > max) errors[path] = `Enter a whole number from ${min} to ${max}.`;
  };
  if (chat.enabled === 'Yes') {
    if (chat.turn_timeout_seconds != null && chat.turn_timeout_seconds !== '' && (!Number.isFinite(chat.turn_timeout_seconds) || chat.turn_timeout_seconds < 0)) {
      errors['chat.turn_timeout_seconds'] = 'Enter Chat Turn Timeout Seconds as 0 or greater.';
    }
    integer(chat.session.max_message_characters, 1, 10000, 'chat.session.max_message_characters');
    integer(chat.session.max_user_messages, 1, 10000, 'chat.session.max_user_messages');
    for (const [key, label] of [['tool_wait_delay_seconds', 'Tool Wait Message Delay Seconds'], ['turn_wait_seconds', 'User Turn Wait Seconds'], ['typing_wait_seconds', 'User Typing Wait Seconds']]) {
      if (chat[key] != null && chat[key] !== '' && (!Number.isFinite(chat[key]) || chat[key] < 0 || chat[key] > 60)) errors[`chat.${key}`] = `Enter ${label} from 0 to 60.`;
    }
  }
  return errors;
};
